module.exports = __webpack_public_path__ + "img/nanhaishengmiao.0d2fe704.jpg";